import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Section } from '../ui/Section'
import { Container } from '../ui/Container'
import { SectionTitle } from '../ui/SectionTitle'
import { Button } from '../ui/Button'
import { Upload } from 'lucide-react'

export function CareersForm() {
  const { t } = useTranslation()
  const [isSubmitted, setIsSubmitted] = useState(false)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setIsSubmitted(true)
  }

  if (isSubmitted) {
    return (
      <Section variant="dark">
        <Container>
          <div className="max-w-2xl mx-auto text-center py-12">
            <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-10 h-10 text-dark" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">
              {t('careers.form.success')}
            </h2>
          </div>
        </Container>
      </Section>
    )
  }

  return (
    <Section variant="dark">
      <Container>
        <div className="max-w-2xl mx-auto w-full">
          <SectionTitle
            title={t('careers.form.title')}
            subtitle={t('careers.form.subtitle')}
            centered
            light
          />

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="career-name" className="block text-sm font-medium text-gray-300 mb-2">
                  {t('careers.form.name')}
                </label>
                <input
                  type="text"
                  id="career-name"
                  name="name"
                  required
                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-gray-400 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                />
              </div>
              <div>
                <label htmlFor="career-email" className="block text-sm font-medium text-gray-300 mb-2">
                  {t('careers.form.email')}
                </label>
                <input
                  type="email"
                  id="career-email"
                  name="email"
                  required
                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-gray-400 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="career-phone" className="block text-sm font-medium text-gray-300 mb-2">
                  {t('careers.form.phone')}
                </label>
                <input
                  type="tel"
                  id="career-phone"
                  name="phone"
                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-gray-400 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                />
              </div>
              <div>
                <label htmlFor="career-position" className="block text-sm font-medium text-gray-300 mb-2">
                  {t('careers.form.position')}
                </label>
                <input
                  type="text"
                  id="career-position"
                  name="position"
                  className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-gray-400 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all"
                />
              </div>
            </div>

            <div>
              <label htmlFor="career-message" className="block text-sm font-medium text-gray-300 mb-2">
                {t('careers.form.message')}
              </label>
              <textarea
                id="career-message"
                name="message"
                rows={4}
                className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-gray-400 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all resize-none"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                {t('careers.form.cv')}
              </label>
              <div className="border-2 border-dashed border-white/20 rounded-lg p-8 text-center hover:border-primary transition-colors cursor-pointer">
                <Upload className="w-8 h-8 text-gray-400 mx-auto mb-2" />
                <p className="text-gray-400 text-sm">
                  {t('careers.form.dragCV')}
                </p>
                <input type="file" accept=".pdf" className="hidden" />
              </div>
            </div>

            <div className="text-center">
              <Button type="submit" size="lg">
                {t('careers.form.submit')}
              </Button>
            </div>
          </form>
        </div>
      </Container>
    </Section>
  )
}
